import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import localeCore from "../../core/locale.core";
import pickupAddrCore from "../../core/pickupAddr.core";
import { useTranslation } from "../../core/translation.core";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { PickupAddr } from "../../types/pickupAddr";
import { UseFormReturn } from "react-hook-form";
import { useEffect, useState } from "react";

export default function ShipInfoCreatorPickup({ methods, pickupAddrs }: { methods: UseFormReturn<any>; pickupAddrs: PickupAddr[] }) {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div id="pickup-list">
      {pickupAddrs.length > 0 ?  pickupAddrs.map((p) => (
        <Addr key={p.id} pickupAddr={p} methods={methods} isSelected={selectedId === p.id} onSelect={() => setSelectedId(p.id)} />
      )) : <p>No Pickup Addresses created yet</p>}
    </div>
  );
}

const Addr = ({
  pickupAddr,
  methods,
  isSelected,
  onSelect,
}: {
  pickupAddr: PickupAddr;
  methods: UseFormReturn<any>;
  isSelected: boolean;
  onSelect: () => void;
}) => {
  const { locale, isReady } = useRouter();
  const { t, msg } = useTranslation();

  if (!isReady) return null;

  const handleSelectAddress = () => {
    methods.setValue("pickupAddrId", pickupAddr.id);
    console.log("selected address", pickupAddr.id)
    onSelect();
  };

  return (
    <div className={`border p-2 pr-6 relative ${isSelected ? "border-blue-700" : ""}`} data-id={pickupAddr.id}>
      <button type="button" className="right-2 absolute underline cursor-pointer" onClick={handleSelectAddress}>
        {t(msg.form.select)}
      </button>
      <p>{pickupAddr.country}</p>
      <p>{localeCore.getLocaleValue(pickupAddr.addr, locale)}</p>
    </div>
  );
};
